import React, { lazy, Suspense, memo } from 'react';
import PropTypes from 'prop-types';
import { Routes, Route, Navigate } from 'react-router-dom';

import LoadingScreen from './components/LoadingScreen.react';

import DashboardLayout from './layouts/dashboardLayout';
import SurveyLayout from './layouts/SurveyLayout';
import BusinessCasePage from './pages/businessCase';
import SolutionLayout from './layouts/SolutionLayout';
import LoadingPage from './pages/loadingPage';

// Lazy-loaded Pages
const LandingPage = lazy(() => import('src/pages/landingPage'));

const QuestionsOne = lazy(() => import('src/pages/survey/question_1'));
const QuestionsTwo = lazy(() => import('src/pages/survey/question_2'));
const QuestionsThree = lazy(() => import('src/pages/survey/question_3'));
const QuestionsFour = lazy(() => import('src/pages/survey/question_4'));

const SolutionPage = lazy(() => import('src/pages/solutionPage'));

//
// Wrapper Components
//
function DashboardHomeWithLayout() {
  return (
    <DashboardLayout>
      <LandingPage />
    </DashboardLayout>
  );
}

function QuestionsOneWithLayout() {
  return (
    <SurveyLayout>
      <QuestionsOne />
    </SurveyLayout>
  );
}

function SolutionWithLayout() {
  return (
    <SolutionLayout showButton>
      <SolutionPage />
    </SolutionLayout>
  );
}

function LoadingWithLayout() {
  return (
    <SurveyLayout withoutStepper>
      <LoadingPage />
    </SurveyLayout>
  );
}
function QuestionsTwoWithLayout() {
  return (
    <SurveyLayout>
      <QuestionsTwo />
    </SurveyLayout>
  );
}

function QuestionsThreeWithLayout() {
  return (
    <SurveyLayout>
      <QuestionsThree />
    </SurveyLayout>
  );
}

function QuestionsFourWithLayout() {
  return (
    <SurveyLayout>
      <QuestionsFour />
    </SurveyLayout>
  );
}

function BusinessCaseWithLayout() {
  return (
    <SolutionLayout showButton>
      <BusinessCasePage />
    </SolutionLayout>
  );
}

//
// Final AppRoutes Component
//
const AppRoutes = memo(function AppRoutes() {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <Routes>
        {/* Direct Routes without AuthGuard */}
        <Route path="/" element={<DashboardHomeWithLayout />} />
        <Route path="/survey/question_1" element={<QuestionsOneWithLayout />} />

        <Route path="/survey/question_2" element={<QuestionsTwoWithLayout />} />
        <Route
          path="/survey/question_3"
          element={<QuestionsThreeWithLayout />}
        />
        <Route
          path="/survey/question_4"
          element={<QuestionsFourWithLayout />}
        />
        <Route path="/business-case" element={<BusinessCaseWithLayout />} />
        {/* Redirects */}
        <Route path="/loading" element={<LoadingWithLayout />} />
        <Route path="/solution" element={<SolutionWithLayout />} />

        <Route path="/" element={<Navigate to="/app/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/app/dashboard" replace />} />
      </Routes>
    </Suspense>
  );
});

AppRoutes.propTypes = {
  role: PropTypes.shape({
    name: PropTypes.string,
    permissions: PropTypes.arrayOf(PropTypes.string)
  })
};
export default AppRoutes;
